export default __webpack_public_path__ + "static/media/Logotype-Colored.svg";